import { z } from "zod";

import { ValidationError } from "../../errors";
import { defineModel } from "../types";

const sunoMusicParams = z
  .object({
    // prompt comes from step level, merged into params at runtime
    prompt: z.string().default(""),
    instrumental: z.boolean().default(true),
  })
  .strip();

export type SunoMusicParams = z.infer<typeof sunoMusicParams>;

export const sunoMusic = defineModel({
  key: "suno-music",
  stepType: "music",
  spec: {
    label: "Suno Music",
    description: "Generate AI music from a text prompt",
    icon: "music-icon.svg",
    tags: ["music-gen"],
    featured: true,
    features: {
      prompts: true,
    } as const,
    options: {},
    params: sunoMusicParams,
  },
  providers: [
    {
      provider: "kie",
      modelId: "suno",
      estimateCost: (_params) => {
        // KIE Suno pricing: 12 credits = $0.06 per generation
        return 60_000; // microdollars
      },
      toPayload: (params) => {
        if (!params?.prompt?.length) {
          throw new ValidationError("Please enter a prompt to generate music.");
        }

        // KIE Suno rejects prompts over 500 chars with a 422 in non-custom mode.
        const NON_CUSTOM_PROMPT_MAX_CHARS = 500;
        return {
          prompt: params.prompt.slice(0, NON_CUSTOM_PROMPT_MAX_CHARS),
          model: "V5" as const, // Always use V5 (latest, best quality)
          instrumental: params.instrumental ?? true,
          customMode: false,
        };
      },
    },
  ],
});
